import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { image as imagePropType } from 'lib/CustomPropTypes';
import { replaceAmpersands } from 'lib/stringUtils';

const Caption = ({ image, className }) => {
  const {
    caption,
    authors,
    source,
  } = image;

  // Image rights
  let rights;

  // Check if author value is empty string
  const hasAuthor = get(authors, '[0].name.length', false);

  // Check if source value is empty string.
  const hasSource = get(source, 'name.length', false);

  if (hasAuthor) {
    rights = `${authors[0].name}${hasSource ? ` / ${source.name}` : ''}`;
  } else if (hasSource) {
    rights = source.name;
  }

  if (caption || rights) {
    const captionClasses = classNames(
      'caption',
      className, // Overrides from parent component
    );

    return (
      <figcaption className={captionClasses}>
        <span className="caption__container">
          {replaceAmpersands(caption)}
        </span>
        {rights && (
          <span className="caption__source">
            {replaceAmpersands(rights)}
          </span>
        )}
      </figcaption>
    );
  }

  return null;
};

Caption.propTypes = {
  image: imagePropType.isRequired,
  className: PropTypes.string,
};

Caption.defaultProps = {
  className: '',
};

export default Caption;
